import { render, staticRenderFns } from "./DadoPessoal.vue?vue&type=template&id=5d1902df&scoped=true&"
import script from "./DadoPessoal.vue?vue&type=script&lang=js&"
export * from "./DadoPessoal.vue?vue&type=script&lang=js&"
import style0 from "./DadoPessoal.vue?vue&type=style&index=0&id=5d1902df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1902df",
  null
  
)

export default component.exports